import { QueryEntity } from "@datorama/akita";
import { map } from "rxjs";
import { singleton } from "tsyringe";

import WishlistsStore, { WishlistsState } from "../stores/WishlistsStore";

@singleton()
export class WishlistsQuery extends QueryEntity<WishlistsState> {
    constructor(wishlistsStore: WishlistsStore) {
        super(wishlistsStore);
    }

    itemsTotalCount$ = this.select((s) => s.itemsTotalCount);
    status$ = this.select((s) => s.status);
    saveStatus$ = this.select((s) => s.saveStatus);
    loadMoreStatus$ = this.select((s) => s.loadMoreStatus);
    sendNotificationToApproversStatus$ = this.select(
        (s) => s.sendNotificationToApproversStatus
    );
    createDraftOrderStatus$ = this.select((s) => s.createDraftOrderStatus);
    approveWishlistStatus$ = this.select((s) => s.approveWishlistStatus);
    error$ = this.selectError();

    hasAnyItems$ = this.selectAll().pipe(
        map((wishlists) =>
            wishlists.some((wishlist) => wishlist.items.length > 0)
        )
    );
}
